export const POST_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS =
  'user.investor.POST_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS'
export const ACCEPT_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS =
  'user.investor.ACCEPT_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS'
